module.exports = __webpack_public_path__ + "assets/img/search.2019e7f8.png";